// extracted by mini-css-extract-plugin
export var backdropBlur = "_cz-0";
export var contentCard = "_cz-5";
export var frame = "_cz-2";
export var image = "_cz-4";
export var imagePane = "_cz-3";
export var modal = "_cz-1";